module.exports = __webpack_public_path__ + "img/teams-down-arrow.0b67dfae.svg";